"use strict";
exports.__esModule = true;
var compare_value_component_1 = require("workbenchRoot/widgets/action/compare-value2/compare-value.component");
var compare_experiment_component_1 = require("workbenchRoot/widgets/action/compare-experiment/compare-experiment.component");
var discovery_breakdown_component_1 = require("workbenchRoot/widgets/action/discovery-breakdown/discovery-breakdown.component");
var program_overview_component_1 = require("workbenchRoot/widgets/action/program-overview/program-overview.component");
var table_input_component_1 = require("workbenchRoot/widgets/action/table-input2/table-input.component");
var table_input_mult_component_1 = require("workbenchRoot/widgets/action/table-input-mult/table-input-mult.component");
var gmf_commercial_component_1 = require("workbenchRoot/widgets/action/gmf-commercial/gmf-commercial.component");
var bucket_chart_component_1 = require("workbenchRoot/widgets/action/bucket-chart2/bucket-chart.component");
var simple_table_component_1 = require("workbenchRoot/widgets/action/simple-table/simple-table.component");
angular.module('smartorg.r6.navs.workspace', [
    require('workbenchRoot/components/sticky-bar/app/js/plumbing/app'),
    require('workbenchRoot/components/chart-table/chart-table.component'),
    require('workbenchRoot/components/issue-modal/issue-modal.component'),
    // All nodes
    require('workbenchRoot/widgets/action/smart-text/app/js/plumbing/app'),
    require('workbenchRoot/widgets/action/intro-box/app/js/plumbing/app'),
    // Leaf level
    require('workbenchRoot/widgets/action/tornado/app/js/plumbing/app'),
    require('workbenchRoot/widgets/action/image/app/js/plumbing/app'),
    simple_table_component_1["default"],
    // require('workbenchRoot/widgets/action/table/app/js/plumbing/app'),
    require('workbenchRoot/widgets/action/input-screen/app/js/plumbing/app'),
    require('workbenchRoot/widgets/action/project-category-assignment/project-category-assignment.component'),
    table_input_component_1["default"],
    table_input_mult_component_1["default"],
    // require('workbenchRoot/widgets/action/table-input/app/js/plumbing/app'),
    // require('workbenchRoot/widgets/action/waterfall/waterfall.component'),
    require('workbenchRoot/widgets/action/waterfall2/waterfall.component'),
    require('workbenchRoot/widgets/action/efficient-frontier/efficient-frontier.component'),
    // Portfolio level
    // require('workbenchRoot/widgets/action/compare-uncertainty/app/js/plumbing/app'),
    require('workbenchRoot/widgets/action/compare-uncertainty2/compare-uncertainty.component'),
    require('workbenchRoot/widgets/action/issue-analysis/issue-analysis.component'),
    // require('workbenchRoot/widgets/action/compare-value/app/js/plumbing/app'),
    compare_value_component_1["default"],
    compare_experiment_component_1["default"],
    gmf_commercial_component_1["default"],
    discovery_breakdown_component_1["default"],
    // require('workbenchRoot/widgets/action/scatter-plot/app/js/plumbing/app'),
    require('workbenchRoot/widgets/action/scatter-plot2/scatter-plot.component'),
    // require('workbenchRoot/widgets/action/innovation-screen/app/js/plumbing/app'),
    require('workbenchRoot/widgets/action/innovation-screen2/innovation-screen.component'),
    require('workbenchRoot/widgets/action/promise-tracking/promise-tracking.component'),
    // require('workbenchRoot/widgets/action/efficient-frontier/app/js/plumbing/app'),
    require('workbenchRoot/widgets/action/cfo-chart/cfo-chart.component'),
    require('workbenchRoot/widgets/action/add-tables/app/js/plumbing/app'),
    // require('workbenchRoot/widgets/action/bucket-chart/app/js/plumbing/app'),
    bucket_chart_component_1["default"],
    require('workbenchRoot/widgets/action/metalog/app/js/plumbing/app'),
    require('workbenchRoot/widgets/action/portfolio-uncertainty/app/js/plumbing/app'),
    require('workbenchRoot/widgets/action/portfolio-uncertainty2/portfolio-uncertainty2.component'),
    require('workbenchRoot/widgets/action/goal-analysis/goal-analysis.component'),
    require('workbenchRoot/widgets/action/common-data/app/js/plumbing/app'),
    // require('workbenchRoot/widgets/action/bubble-chart/app/js/plumbing/app'),
    require('workbenchRoot/widgets/action/bubble-chart2/bubble-chart.component'),
    require('workbenchRoot/widgets/action/efficient-frontier-port/efficient-frontier-port.component'),
    require('workbenchRoot/widgets/action/efport-table/efport-table.component'),
    require('workbenchRoot/widgets/action/envelope-chart/envelope-chart.component'),
    require('workbenchRoot/widgets/action/add-envelope/add-envelope.component'),
    // All nodes
    require('workbenchRoot/widgets/action/universal-io/app/app'),
    program_overview_component_1["default"],
    // INAV
    require('workbenchRoot/widgets/action/scoring/scoring.component'),
    require('workbenchRoot/widgets/action/experiment-management/experiment-management.component'),
    require('workbenchRoot/widgets/action/dashboard/dashboard.component'),
    require('workbenchRoot/widgets/action/executive-dashboard/executive-dashboard.component'),
    require('workbenchRoot/widgets/action/discovery-grid/discovery-grid.component'),
    require('workbenchRoot/widgets/action/experiment-priority/experiment-priority.component'),
    require('workbenchRoot/widgets/action/learning-plan/learning-plan.component'),
    require('workbenchRoot/widgets/action/pdf-viewer/pdf-viewer.component'),
    require('workbenchRoot/widgets/action/dfv/dfv.component'),
    require('workbenchRoot/widgets/action/swot/swot.component'),
    require('workbenchRoot/widgets/action/lt-uncertain-alt/lt-uncertain-alt.component'),
    require('workbenchRoot/widgets/action/ability-to-launch/ability-to-launch.component'),
    require('workbenchRoot/widgets/action/craft-experiment/craft-experiment.component'),
    require('workbenchRoot/widgets/action/learning-plan-new/new-learning-plan.component'),
    require('workbenchRoot/widgets/action/issue-view/issue-view.component'),
    require('workbenchRoot/widgets/action/experiment-view/experiment-view.component'),
    require('workbenchRoot/widgets/action/impact/impact.component'),
    require('workbenchRoot/widgets/action/ignorance-board/ignorance-board.component'),
    require('workbenchRoot/widgets/action/table-scale/table-scale.component'),
    require('workbenchRoot/widgets/action/n-column-canvas/n-column-canvas.component'),
    require('workbenchRoot/widgets/action/n-column-canvas/n-column-canvas.component'),
    require('workbenchRoot/widgets/action/cfo-exp/cfo-exp.component'),
]);
require('./workspace-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.navs.workspace';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/workspace/app/js/plumbing/app.js